/* SystemConfigurationRenderer.js */

"use strict";
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const TextControl = uiCore.Control.Textfield.InputText;
const InputRadioControl = uiCore.Control.OptionSelection.Single.InputRadio;
const SingleComboBox = uiCore.Control.OptionSelection.Single.ComboBox;
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const TextareaControl = uiCore.Control.Textfield.Textarea;
const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;
class SystemConfigurationRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("configuration-gl");
        this._rootElem.component = model;

        this._headerElem = document.createElement("h1");
        this._headerElem.innerText = "Configuration";
        this._mainContainer = document.createElement("container-main");

        this._SMTPContent = document.createDocumentFragment();
        this._proxyContent = document.createDocumentFragment();
        this._dcContent = document.createDocumentFragment();
        this._genAiContent = document.createDocumentFragment();

        this._smtpBasicContainer = document.createElement("div");
        this._smtpBasicContainer.classList.add("smtp-basic", "hidden");

        this._smtpNoConnectionsEl = this._getNoConnectionElement("SMTP");

        this._sFormElem = document.createElement("div");
        this._sFormElem.classList.add("smtp-form", "settings-form");

        this._proxyBasicContainer = document.createElement("div");
        this._proxyBasicContainer.classList.add("proxy-basic", "hidden");

        this._proxyAdvContainer = document.createElement("div");
        this._proxyAdvContainer.classList.add("proxy-advanced", "hidden");

        this._pFormElem = document.createElement("div");
        this._pFormElem.classList.add("proxy-form", "settings-form");

        this._dcFormElem = document.createElement("div");
        this._dcFormElem.classList.add("dc-form", "settings-form");

        this._genAiFormElem = document.createElement("div");
        this._genAiFormElem.classList.add("gen-ai-form", "settings-form");

        this._SMTPContent.appendChild(this._sFormElem);
        this._proxyContent.appendChild(this._pFormElem);
        this._dcContent.appendChild(this._dcFormElem);
        this._genAiContent.appendChild(this._genAiFormElem);

        this._sFieldsSection = document.createElement("div");
        this._sFieldsSection.classList.add("smtp-form-fields", "form-fields");
        this._pFieldsSection = document.createElement("div");
        this._pFieldsSection.classList.add("proxy-form-fields", "form-fields");

        this._isSmtpValid = false;
        this._isProxyValid = false;
        this._isSmtpJsonValid = true;
        this._isProxyJsonValid = true;
        this._smtpErrors = [];
        this._proxyErrors = [];
        /* SMTP Controls */
        this._smtpConfigConnection = new SingleComboBox({
            darkTheme: true,
            required: true,
        });

        /* SMTP Controls End */

        /* Proxy Controls */
        this._proxyConfigType = new InputRadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "Basic",
                    tooltip: "Enter settings for your HTTP proxy server in the form",
                    value: false,
                },
                {
                    label: "Advanced",
                    tooltip: "Paste settings for your HTTP proxy in a JSON configuration",
                    value: true,
                },
            ],
            value: false,
        });
        this._proxyHttp = new TextControl({
            darkTheme: true,
            label: "HTTP Proxy",
            title: "URL of your HTTP proxy server (FQDN or IP address)",
            class: "proxy-http",
        });
        this._proxyCertificate = new TextareaControl({
            darkTheme: true,
        });
        this._proxyAdvArea = new TextareaControl({
            darkTheme: true,
        });

        /* Proxy Controls End */

        this._genAiCheckBox = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Enable Gluware Titan Co-Pilot",
            title: "Enable Gluware Titan Co-Pilot",
            disabled: false,
        });

        this._dcCheckBox = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Enable Distribution Center",
            title: "Enable Distribution Center",
            disabled: false,
        });

        this._smtpSave = new ButtonControl({
            active: false,
            class: "update-smtp-settings",
            darkTheme: true,
            label: "Save",
            disabled: true,
        });

        this._smtpCancel = new ButtonControl({
            class: "cancel",
            darkTheme: true,
            label: "Cancel",
            disabled: true,
        });

        this._proxySave = new ButtonControl({
            active: false,
            class: "update-proxy-settings",
            darkTheme: true,
            label: "Save",
            disabled: true,
        });

        this._proxyCancel = new ButtonControl({
            class: "cancel",
            darkTheme: true,
            label: "Cancel",
            disabled: true,
        });

        this._proxyTestConnection = new ButtonControl({
            class: "test-proxy",
            darkTheme: true,
            label: "Test Proxy connection",
            title: "Test Proxy Connection",
            disabled: false,
        });

        this._dcSave = new ButtonControl({
            active: false,
            class: "update-dc-settings",
            darkTheme: true,
            label: "Save",
            disabled: true,
        });

        this._dcCancel = new ButtonControl({
            class: "cancel",
            darkTheme: true,
            label: "Cancel",
            disabled: true,
        });

        this._dcTestConnection = new ButtonControl({
            class: "test-dc",
            darkTheme: true,
            label: "Test Distribution Center connection",
            title: "Test connection to the Gluware Distribution Center",
            disabled: false,
        });

        this._genAiCancel = new ButtonControl({
            class: "cancel",
            darkTheme: true,
            label: "Cancel",
            disabled: true,
        });

        this._genAiSave = new ButtonControl({
            active: false,
            class: "update-gen-ai-settings",
            darkTheme: true,
            label: "Save",
            disabled: true,
        });

        this._smtpTestConnection = new ButtonControl({
            class: "test-smtp",
            darkTheme: true,
            label: "Send Test Email",
            title: "Send test email from Gluware",
            disabled: false,
        });

        this._addNewConnectionButton = new ButtonControl({
            label: "Add Connection",
            darkTheme: true,
            class: "add-connection-button",
        });

        this._dcFormElem.appendChild(this._dcCheckBox._renderer._rootElem);
        this._genAiFormElem.appendChild(this._genAiCheckBox._renderer._rootElem);

        this._pFormElem.appendChild(this._proxyConfigType._renderer._rootElem);
        this._pFormElem.appendChild(this._proxyBasicContainer);
        this._pFormElem.appendChild(this._proxyAdvContainer);

        this._sFormElem.appendChild(this._smtpBasicContainer);
        this._sFormElem.appendChild(this._smtpNoConnectionsEl);

        this._sActionsContainer = document.createElement("actions-container");
        this._sActionsContainer.classList.add("action-container", "smtp-actions");

        this._pActionsContainer = document.createElement("actions-container");
        this._pActionsContainer.classList.add("action-container", "proxy-actions");

        this._dcActionsContainer = document.createElement("actions-container");
        this._dcActionsContainer.classList.add("action-container", "dc-actions");

        this._genAiActionsContainer = document.createElement("actions-container");
        this._genAiActionsContainer.classList.add("action-container", "gen-ai-actions");

        this._smtpControls = [
            this._smtpSave,
            this._smtpCancel,
            this._smtpConfigConnection,
            this._smtpTestConnection,
            this._addNewConnectionButton,
        ];

        this._proxyControls = [
            this._proxySave,
            this._proxyCancel,
            this._proxyHttp,
            this._proxyTestConnection,
            this._proxyAdvArea,
            this._proxyCertificate,
        ];
        this._controls = [].concat(this._smtpControls, this._proxyControls);
        // Regex validator strings

        this._HostRegex = new RegExp(
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9-]*[A-Za-z0-9])()$/
        );
        this._EmailRegex = new RegExp(
            /^(.*\s<(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))>)|((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))$/
        );
        this._GlURLRegex = new RegExp( //eslint-disable-next-line
            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/
        ); // eslint-disable-line

        this._handleConnectionsLinkClick = this._handleConnectionsLinkClick.bind(this);

        this._registerListeners();
    }

    get rootElement() {
        return this.getRootElement();
    }
    get model() {
        return this.getModel();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._smtpSave.on(
            "UserClick",
            (this._submitSmtpAction = this._submitSmtpAction.bind(this))
        );
        this._smtpCancel.on(
            "UserClick",
            (this._cancelSmtpAction = this._cancelSmtpAction.bind(this))
        );

        this._proxySave.on(
            "UserClick",
            (this._submitProxyAction = this._submitProxyAction.bind(this))
        );
        this._proxyCancel.on(
            "UserClick",
            (this._cancelProxyAction = this._cancelProxyAction.bind(this))
        );

        this._dcSave.on("UserClick", (this._submitDCAction = this._submitDCAction.bind(this)));
        this._dcCancel.on("UserClick", (this._cancelDCAction = this._cancelDCAction.bind(this)));

        this._genAiSave.on(
            "UserClick",
            (this._submitGenAiAction = this._submitGenAiAction.bind(this))
        );
        this._genAiCancel.on(
            "UserClick",
            (this._cancelGenAiAction = this._cancelGenAiAction.bind(this))
        );

        this._registerSmtpListeners();
        this._registerProxyListeners();
        this._registerDCListeners();
        this._registerGenAiListeners();
    }

    _registerSmtpListeners() {
        this._smtpConfigConnection.on(
            "UserValue",
            (this._onSmtpConnectionChange = this._onSmtpConnectionChange.bind(this))
        );
        // this._smtpRejectUnAuthed.on("UserValue", this._onSmtpRejectUnAuthed = this._onSmtpRejectUnAuthed.bind(this));
        this._smtpTestConnection.on("UserClick", (this._onTestSmtp = this._onTestSmtp.bind(this)));
        this._addNewConnectionButton.on(
            "UserClick",
            (this._newConnectionAction = this._newConnectionAction.bind(this))
        );
        this._connectionsLinkEl.addEventListener("click", this._handleConnectionsLinkClick);
    }

    _registerProxyListeners() {
        this._proxyHttp.on("UserValue", (this._onProxyHttp = this._onProxyHttp.bind(this)));
        this._proxyConfigType.on(
            "UserValue",
            (this._onProxyConfigTypeChange = this._onProxyConfigTypeChange.bind(this))
        );
        this._proxyCertificate.on(
            "UserValue",
            (this._onProxyCertificate = this._onProxyCertificate.bind(this))
        );
        this._proxyAdvArea.on("UserValue", (this._onProxyAdv = this._onProxyAdv.bind(this)));
        this._proxyTestConnection.on(
            "UserClick",
            (this._onTestProxy = this._onTestProxy.bind(this))
        );
    }

    _registerDCListeners() {
        this._dcCheckBox.on("UserValue", (this._onEnableDC = this._onEnableDC.bind(this)));
        this._dcTestConnection.on("UserClick", (this._onTestDC = this._onTestDC.bind(this)));
    }

    _registerGenAiListeners() {
        this._genAiCheckBox.on("UserValue", (this._onEnableGenAi = this._onEnableGenAi.bind(this)));
    }

    _unregisterProxyListeners() {
        this._proxyHttp.removeListener("UserValue", this._onProxyHttp);
        this._proxyConfigType.removeListener("UserValue", this._onProxyConfigTypeChange);
        this._proxyCertificate.removeListener("UserValue", this._onProxyCertificate);
        this._proxyAdvArea.removeListener("UserValue", this._onProxyAdv);
        this._proxyTestConnection.removeListener("UserClick", this._onTestProxy);
    }

    _unregisterSmtpListeners() {
        this._smtpConfigConnection.removeListener("UserValue", this._onSmtpConnectionChange);
        this._smtpTestConnection.removeListener("UserClick", this._onTestSmtp);
        this._addNewConnectionButton.removeListener("UserClick", this._newConnectionAction);
        this._connectionsLinkEl.removeEventListener("click", this._handleConnectionsLinkClick);
    }

    _unregisterDCListeners() {
        this._dcCheckBox.removeListener("UserValue", this._onEnableDC);
        this._dcTestConnection.removeListener("UserClick", this._onTestDC);
    }

    _unregisterGenAiListeners() {
        this._genAiCheckBox.removeListener("UserValue", this._onEnableGenAi);
    }

    _unregisterListeners() {
        this._smtpSave.removeListener("UserClick", this._submitSmtpAction);
        this._smtpCancel.removeListener("UserClick", this._cancelSmtpAction);
        this._proxySave.removeListener("UserClick", this._submitProxyAction);
        this._proxyCancel.removeListener("UserClick", this._cancelProxyAction);
        this._dcSave.removeListener("UserClick", this._submitDCAction);
        this._dcCancel.removeListener("UserClick", this._cancelDCAction);
        this._unregisterSmtpListeners();
        this._unregisterProxyListeners();
        this._unregisterDCListeners();
        this._unregisterGenAiListeners();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    getRootElement() {
        return this._rootElem;
    }
    getModel() {
        return this._model;
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (this._model) {
            return this._model
                .whenModelIsReady()
                .then(() => {
                    if (this._rootElem) {
                        this._smtpConfigConnection.setOptions(
                            this._model._smtpServiceConnectionOpts
                        );
                        this._rootElem.innerHTML = "";
                        this._rootElem.appendChild(this._headerElem);
                        this._rootElem.appendChild(this._mainContainer);
                        this._showControls();

                        this._mainContainer.appendChild(
                            this._createSection(this._dcContent, {
                                title: "Gluware Distribution Center",
                                className: "dc-section",
                                bordered: true,
                            })
                        );

                        this._mainContainer.appendChild(
                            this._createSection(this._SMTPContent, {
                                title: "SMTP Settings",
                                className: "smtp-section",
                                bordered: true,
                            })
                        );

                        this._mainContainer.appendChild(
                            this._createSection(this._proxyContent, {
                                title: "Proxy Settings",
                                className: "proxy-section",
                                bordered: true,
                            })
                        );

                        this._mainContainer.appendChild(
                            this._createSection(this._genAiContent, {
                                title: "Gluware Titan",
                                className: "glu-ai-section",
                                bordered: true,
                            })
                        );

                        this._showForm();
                        // this._enableProxyFileds();
                        this._updateSmtpData(this._model._emailConfig);
                        this._onSmtpConnectionChange(this._smtpConfigConnection.getValue());
                        this._enableDisableSmtpSection(
                            !!this._model._smtpServiceConnectionEntities.length
                        );
                        return this._updateProxyData(this._model._proxyConfig);
                    }
                })
                .then(() => {
                    this._showHideAdvancedProxy(this._model._proxyConfig.advanced);
                    this._isSmtpValid = this._validateSmtp();
                    this._isProxyValid = this._validateProxy();
                    this._dcCheckBox.setValue(this._model._dcEnabled);
                    this._genAiCheckBox.setValue(this._model._genAiEnabled);
                    this._dcTestConnection.setDisabled(!this._model._dcEnabled);
                    this._updateSmtpActionState();
                    this._updateProxyActionState();
                    this._isSmtpValid = true; // Setting to true after initial button state
                    this._isProxyValid = true; // so that they dont interfere with dirty state button states
                    if (this._model._myUserInfo.authorizedActions.indexOf("configWrite") < 0) {
                        this._disableSmtpFields();
                    }
                })
                .catch(console.error);
        }
    }

    _updateSmtpData(data) {
        this._smtpConfigConnection.setValue(
            _.get(
                data,
                "serviceConnectionId",
                _.get(this._model._smtpServiceConnectionEntities[0], "id")
            )
        );
    }

    _enableDisableSmtpSection(state = true) {
        this._smtpConfigConnection.setDisabled(!state);
        this._smtpSave.setDisabled(!state);
        this._smtpCancel.setDisabled(!state);
        this._smtpTestConnection.setDisabled(!state);
        this._addNewConnectionButton.setDisabled(!state);
        if (state) {
            this._smtpBasicContainer.classList.remove("hidden");
            this._smtpNoConnectionsEl.classList.add("hidden");
            this._sActionsContainer.classList.remove("hidden");
        } else {
            this._smtpBasicContainer.classList.add("hidden");
            this._smtpNoConnectionsEl.classList.remove("hidden");
            this._sActionsContainer.classList.add("hidden");
        }
    }

    async _updateProxyData(data) {
        if (!data) {
            return;
        }
        this._proxyConfigType.setValue(data.advanced || false);
        this._proxyHttp.setValue(data.proxy);
        this._proxyCertificate.setValue(_.get(data, "agentOptions.ca", ""));

        if (data.advanced) {
            //does _retrieveNameForCredential ever exist?
            try {
                await this._model._retrieveNameForCredential(
                    _.get(data, "agentOptions.passphrase"),
                    _.get(data, "agentOptions"),
                    "passphrase"
                );
            } catch (error) {
                console.warn("Failed to retrieve name for credential", error);
            }
        }

        this._proxyAdvArea.setValue(
            JSON.stringify(_.pick(data, ["proxy", "agentOptions"]), undefined, 4)
        );

        return Promise.resolve();
    }

    shutdown() {
        this._unregisterListeners();

        return Promise.all(_.invokeMap(this._controls, "shutdown")).then(() => {
            this._rootElem.remove();
            this._headerElem = undefined;
            this._rootElem = undefined;
            this._smtpSave = undefined;
            this._smtpCancel = undefined;
            this._sFormElem = undefined;
            this._sActionsContainer = undefined;
            this._smtpConfigConnection = undefined;
            // this._smtpPassword = undefined;
            this._proxySave = undefined;
            this._proxyCancel = undefined;
            this._proxyHttp = undefined;

            this._pFormElem = undefined;
            this._pActionsContainer = undefined;
            this._sFieldsSection = undefined;
            this._pFieldsSection = undefined;
            this._proxyContent = undefined;
            this._SMTPContent = undefined;
            this._smtpErrors = undefined;
            this._proxyErrors = undefined;
            this._isSmtpJsonValid = undefined;
            this._isProxyJsonValid = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _showControls() {
        this._sActionsContainer.appendChild(this._addNewConnectionButton.renderer.getRootElement());
        this._sActionsContainer.appendChild(this._smtpTestConnection.renderer.getRootElement());
        this._sActionsContainer.appendChild(this._smtpCancel.renderer.getRootElement());
        this._sActionsContainer.appendChild(this._smtpSave.renderer.getRootElement());
        this._SMTPContent.appendChild(this._sActionsContainer);
        this._pActionsContainer.appendChild(this._proxyTestConnection.renderer.getRootElement());
        this._pActionsContainer.appendChild(this._proxyCancel.renderer.getRootElement());
        this._pActionsContainer.appendChild(this._proxySave.renderer.getRootElement());
        this._proxyContent.appendChild(this._pActionsContainer);
        this._dcActionsContainer.appendChild(this._dcTestConnection.renderer.getRootElement());
        this._dcActionsContainer.appendChild(this._dcCancel.renderer.getRootElement());
        this._dcActionsContainer.appendChild(this._dcSave.renderer.getRootElement());
        this._dcContent.appendChild(this._dcActionsContainer);

        this._genAiActionsContainer.appendChild(this._genAiCancel.renderer.getRootElement());
        this._genAiActionsContainer.appendChild(this._genAiSave.renderer.getRootElement());
        this._genAiContent.appendChild(this._genAiActionsContainer);
    }

    _showForm() {
        this._showSMTPForm();
        this._showProxyForm();
    }
    _showSMTPForm() {
        // this._renderFormPair("Email Server Password", "Password for connecting to the mail server", this._smtpPassword,  this._sFieldsSection);

        this._renderFormPair(
            "Connections",
            "Available Connections",
            this._smtpConfigConnection,
            this._sFieldsSection
        );

        this._smtpBasicContainer.appendChild(this._sFieldsSection);
    }
    _showProxyForm() {
        this._renderFormPair(
            "HTTP Proxy",
            "URL of your HTTP proxy server (FQDN or IP address)",
            this._proxyHttp,
            this._pFieldsSection
        );
        this._renderFormPair(
            "Certificate",
            "PEM encoded X.509 certificate for HTTPS",
            this._proxyCertificate,
            this._pFieldsSection
        );
        this._renderFormPair(
            "Configuration",
            "Configuration",
            this._proxyAdvArea,
            this._proxyAdvContainer
        );
        this._proxyBasicContainer.appendChild(this._pFieldsSection);
    }

    _renderFormPair(labelName, title, component, parentEl) {
        const parent = parentEl ? parentEl : this._sFieldsSection;
        let labelElem = document.createElement("label");
        labelElem.innerText = labelName;
        labelElem.setAttribute("title", title);
        let cmpntElem = component.renderer.getRootElement();
        parent.appendChild(labelElem);
        parent.appendChild(cmpntElem);
    }

    _createSection(content, options = {}) {
        const section = document.createElement("section");
        section.className = options.className || "";
        section.classList.toggle("bordered", !!options.bordered);

        if (options.title) {
            const title = document.createElement("h2");
            title.innerText = options.title;
            section.appendChild(title);
        }
        section.appendChild(content);
        return section;
    }

    _getNoConnectionElement(type = "SMTP") {
        const noConnectionElement = document.createElement("div");
        noConnectionElement.classList.add("no-connection");
        this._connectionsLinkEl = document.createElement("a");
        this._connectionsLinkEl.classList.add("connections-link", "hyperlink");
        this._connectionsLinkEl.innerText = "Connections View";
        noConnectionElement.innerHTML = `No Connections available for ${type}.  Please create one in the&nbsp;`;
        const periodEl = document.createElement("span");
        periodEl.innerText = ".";
        noConnectionElement.appendChild(this._connectionsLinkEl);
        noConnectionElement.appendChild(periodEl);
        return noConnectionElement;
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _setSmtpDirtyState() {
        this._model._isSmtpDirty = !_.isEqual(
            this._model._emailConfig,
            this._model._updatedEmailConfig
        );
    }

    _setProxyDirtyState() {
        this._model._isProxyDirty = !_.isEqual(
            this._model._SystemConfig._cleanHttpConfig(this._model._proxyConfig),
            this._model._SystemConfig._cleanHttpConfig(this._model._updatedProxyConfig)
        );
    }

    _setDCDirtyState() {
        this._model._isDCDirty = !_.isEqual(this._model._dcEnabled, this._model._updatedDcEnabled);
    }

    _setGenAiDirtyState() {
        this._model._isGenAiDirty = !_.isEqual(
            this._model._genAiEnabled,
            this._model._updatedGenAiEnabled
        );
    }

    _updateSmtpActionState() {
        if (!this._isSmtpValid) {
            this._disableSmtpActions({acceptBtn: true, cancelBtn: true});
            return;
        }
        if (this._model._isSmtpDirty) {
            this._disableSmtpActions({acceptBtn: false, cancelBtn: false});
        } else {
            this._disableSmtpActions({acceptBtn: true, cancelBtn: true});
        }
    }

    _updateProxyActionState() {
        // Disable test button if proxy value is empty-ish in either mode
        const testBtnDisabled = !this._proxyConfigType.getValue()
            ? _.isEmpty(this._proxyHttp.getValue())
            : _.isEmpty(JSON.parse(this._proxyAdvArea.getValue()).proxy);
        if (!this._isProxyValid) {
            this._proxyTestConnection.setDisabled(true);
            return;
        }
        if (this._model._isProxyDirty) {
            this._disableProxyActions({
                acceptBtn: false,
                cancelBtn: false,
                testBtn: testBtnDisabled,
            });
        } else {
            this._disableProxyActions({acceptBtn: true, cancelBtn: true, testBtn: testBtnDisabled});
        }
    }

    _disableSmtpActions({acceptBtn, cancelBtn}) {
        this._smtpCancel.setDisabled(cancelBtn);
        this._smtpSave.setDisabled(acceptBtn);
        if (!this._validateSmtp()) {
            this._smtpTestConnection.setDisabled(true);
        } else {
            this._smtpTestConnection.setDisabled(false);
        }
    }

    _disableProxyActions({acceptBtn, cancelBtn, testBtn}) {
        this._proxySave.setDisabled(acceptBtn);
        this._proxyCancel.setDisabled(cancelBtn);
        this._proxyTestConnection.setDisabled(testBtn);
        if (!this._validateProxy()) {
            this._proxyTestConnection.setDisabled(true);
        }
    }

    _submitSmtpAction() {
        if (!this._model._isSmtpDirty) {
            this._updateSmtpActionState();
        }
        this._model
            ._saveSmtp()
            .then(() => {
                this._updateSmtpActionState();
            })
            .catch((err) => {
                this._model._displayError([err.message]);
            });
    }

    _onTestProxy() {
        if (this._validateProxy()) {
            this._proxyTestConnection.setDisabled(true);
            this._proxyTestConnection.setLabel("Testing Proxy connection");
            const _testBtnElem = this._proxyTestConnection.renderer.getRootElement();
            _testBtnElem.classList.add("loading");
            setTimeout(() => {
                this._model._testProxy().finally(() => {
                    this._proxyTestConnection.setDisabled(false);
                    this._proxyTestConnection.setLabel("Test Proxy connection");
                    _testBtnElem.classList.remove("loading");
                });
            }, 50);
        } else {
            this._model._displayError(this._proxyErrors);
        }
    }

    _updateDCActionState() {
        this._dcSave.setDisabled(!this._model._isDCDirty);
        this._dcCancel.setDisabled(!this._model._isDCDirty);
        this._dcTestConnection.setDisabled(!this._dcCheckBox.value);
    }

    _updateGenAiActionState() {
        this._genAiSave.setDisabled(!this._model._isGenAiDirty);
        this._genAiCancel.setDisabled(!this._model._isGenAiDirty);
    }

    _onTestDC() {
        this._dcTestConnection.setDisabled(true);
        this._dcTestConnection.setLabel("Testing Distribution Center connection");
        const _testBtnElem = this._dcTestConnection.renderer.getRootElement();
        _testBtnElem.classList.add("loading");
        setTimeout(() => {
            this._model._testDistributionCenter().finally(() => {
                this._dcTestConnection.setDisabled(false);
                this._dcTestConnection.setLabel("Test Distribution Center connection");
                _testBtnElem.classList.remove("loading");
            });
        }, 50);
    }

    _onTestSmtp() {
        this._model._testSmtp();
    }

    _handleConnectionsLinkClick(evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this._newConnectionAction();
    }

    async _newConnectionAction() {
        const routeDetails = this._model._router.getRouteDetails();
        routeDetails.sr = "Organization/Connections";
        // will be called if any section is dirty as the user is trying to navigate away
        if (
            this._model._isSmtpDirty ||
            this._model._isProxyDirty ||
            this._model._isDCDirty ||
            this._model._isGenAiDirty
        ) {
            try {
                await this._model._modalUserFeedback.displayConfirmation(
                    "You have unsaved changes on this page. If you navigate away, your changes will be lost. Do you want to proceed?",
                    {
                        title: "Unsaved Changes",
                        confirmDetails: {
                            text: "OK",
                            type: "destructive",
                        },
                        rejectDetails: {
                            text: "Cancel",
                            type: "text",
                        },
                    }
                );
                this._model._router.goTo(routeDetails);
            } catch (err) {
                if (!err.userRejected) {
                    console.warn(err);
                }
            }
        } else {
            this._model._router.goTo(routeDetails);
        }
    }

    _submitProxyAction() {
        if (this._validateProxyJson()) {
            this._model._saveProxy().then(() => {
                this._updateProxyActionState();
            });
        } else {
            this._model._displayError(this._proxyErrors);
        }
    }

    _submitDCAction() {
        if (this._model._updatedDcEnabled) {
            this._saveAndReset();
        } else {
            this._model._uiutils
                .showDeleteConfirmDialog({
                    message:
                        "Disabling access to the Gluware Distribution Center removes access to the private and shared distribution areas for all organizations. " +
                        "Packages published to these distribution areas cannot be recovered. Are you sure you want to disable access?",
                    confirmButtonName: "Yes",
                    cancelButtonName: "No",
                })
                .then(() => {
                    // warned and proceeding
                    this._dcSave.setDisabled(true); // Instantly disable these, else there
                    this._dcCancel.setDisabled(true); // is 1-2 sec delay and could cause issue
                    this._saveAndReset();
                })
                .catch((error) => {
                    if (error && !error.userRejected) {
                        console.log("Error when disabling DC : _submitDCAction()", error);
                        return this._model && this.model.userFeedback.displayError(error);
                    }
                });
        }
    }

    _submitGenAiAction() {
        this._saveAndResetGenAi();
    }

    _saveAndReset() {
        this._model._saveDC().then(() => {
            this._updateDCActionState();
            this._dcTestConnection.setDisabled(!this._model._dcEnabled);
        });
    }

    _saveAndResetGenAi() {
        this._model._saveEnableGenAi();
    }

    _cancelSmtpAction() {
        let data = this.model._cancelChanges("smtp");
        this._updateSmtpData(data);
        this._updateSmtpActionState();
    }

    async _cancelProxyAction() {
        let data = this.model._cancelChanges("proxy");
        this._showHideAdvancedProxy(data.advanced);
        await this._updateProxyData(data);
        this._updateProxyActionState();
    }

    _cancelDCAction() {
        this._dcCheckBox.setValue(this._model._dcEnabled);
        this._model._updatedDcEnabled = this._model._dcEnabled;
        this._model._isDCDirty = false;
        this._updateDCActionState();
    }

    _cancelGenAiAction() {
        this._genAiCheckBox.setValue(this._model._genAiEnabled);
        this._model._updatedGenAiEnabled = this._model._genAiEnabled;
        this._model._isGenAiDirty = false;
        this._updateGenAiActionState();
    }

    /*
        SMTP Handlers
    */

    _onSmtpConnectionChange(val) {
        _.set(this._model._updatedEmailConfig, "serviceConnectionId", val);
        this._setSmtpDirtyState();
        this._updateSmtpActionState();
    }
    /*
        PROXY handlers
    */
    _onProxyHttp(val) {
        _.set(this._model._updatedProxyConfig, "proxy", val);
        this._setProxyDirtyState();
        this._updateProxyActionState();
    }
    _showHideAdvancedProxy(val = false) {
        if (val) {
            this._proxyBasicContainer.classList.add("hidden");
            this._proxyAdvContainer.classList.remove("hidden");
        } else {
            this._proxyBasicContainer.classList.remove("hidden");
            this._proxyAdvContainer.classList.add("hidden");
        }
    }
    async _onProxyConfigTypeChange(val) {
        this._model._setHttpAdvanced(val);
        this._showHideAdvancedProxy(val);
        await this._updateProxyData(this._model._updatedProxyConfig);
        this._setProxyDirtyState();
        this._updateProxyActionState();
    }

    _onProxyCertificate(val) {
        _.set(this._model, "_updatedProxyConfig.agentOptions.ca", val);
        this._setProxyDirtyState();
        this._updateProxyActionState();
    }

    _onProxyAdv(val) {
        try {
            let httpConfigObj = JSON.parse(val);
            httpConfigObj.advanced = true;
            this._isProxyJsonValid = true;
            _.set(this._model, "_updatedProxyConfig", httpConfigObj);
            this._setProxyDirtyState();
            this._updateProxyActionState();
        } catch (e) {
            this._isProxyJsonValid = false;
            return;
        }
    }

    _onEnableDC(val) {
        _.set(this._model, "_updatedDcEnabled", val);
        this._setDCDirtyState();
        this._updateDCActionState();
    }

    _onEnableGenAi(val) {
        _.set(this._model, "_updatedGenAiEnabled", val);
        this._setGenAiDirtyState();
        this._updateGenAiActionState();
    }

    /* Control change events : End */
    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _validateSmtp() {
        let _isValid = false;
        this._smtpErrors = [];
        if (!this._model._updatedEmailConfig.serviceConnectionId) {
            this._smtpErrors.push({
                key: "SMTP Error",
                err: "A connection is required for SMTP.",
            });
            _isValid = false;
        } else {
            _isValid = true;
        }

        return _isValid;
    }

    _validateProxyJson() {
        if (this._model._updatedProxyConfig.advanced) {
            if (!this._isProxyJsonValid) {
                this._proxyErrors = [];
                this._proxyErrors.push({
                    key: "JSON Error",
                    err: "A valid JSON is required for advanced configuration.",
                });
                return false;
            }
            return true;
        }
        return true;
    }

    _validateProxy() {
        let _isValid = true;
        this._proxyErrors = [];
        if (!this._validateProxyJson()) {
            _isValid = false;
        }
        return _isValid;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = SystemConfigurationRenderer;
